import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faBookmark } from "@fortawesome/free-solid-svg-icons"

export const Bookmark = (props) => {
  return <FontAwesomeIcon faIcon={faBookmark} {...props} />
}
